import { app } from '../../../bootstrap/core';
import positionsTableComponent from './positionsTable.component';

app.component('positionsTable', positionsTableComponent);



// WEBPACK FOOTER //
// ./src/app/common/ui/positionsTable/positionsTable.js